module.exports = __webpack_public_path__ + "static/media/vent_neutre.528fc656.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vent_neutre.svg
// module id = 127
// module chunks = 0